var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 36.75H41.25V7.5C41.25 6.90326 41.0129 6.33097 40.591 5.90901C40.169 5.48705 39.5967 5.25 39 5.25H28.5C27.9033 5.25 27.331 5.48705 26.909 5.90901C26.4871 6.33097 26.25 6.90326 26.25 7.5V14.25H18C17.4033 14.25 16.831 14.4871 16.409 14.909C15.9871 15.331 15.75 15.9033 15.75 16.5V23.25H9C8.40326 23.25 7.83097 23.4871 7.40901 23.909C6.98705 24.331 6.75 24.9033 6.75 25.5V36.75H6C5.40326 36.75 4.83097 36.9871 4.40901 37.409C3.98705 37.831 3.75 38.4033 3.75 39C3.75 39.5967 3.98705 40.169 4.40901 40.591C4.83097 41.0129 5.40326 41.25 6 41.25H42C42.5967 41.25 43.169 41.0129 43.591 40.591C44.0129 40.169 44.25 39.5967 44.25 39C44.25 38.4033 44.0129 37.831 43.591 37.409C43.169 36.9871 42.5967 36.75 42 36.75ZM30.75 9.75H36.75V36.75H30.75V9.75ZM20.25 18.75H26.25V36.75H20.25V18.75ZM11.25 27.75H15.75V36.75H11.25V27.75Z",
    fill: "#012448",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBar);
export default __webpack_public_path__ + "static/media/ChartBar.60541a3b3ec502453fb825069ae3ee31.svg";
export { ForwardRef as ReactComponent };